import { Stack } from '@mui/material';
import { useEffect, useRef } from 'react';

import {
  ErrorLoadingPage,
  FilterSummary,
  Loading,
  NoSearchResults,
  SummaryCardNew,
  useDrawerFilter,
} from '@hapvida/hapvida-core-components';

import { useFilterParams } from '@hooks';

import { useMovementsState } from './hooks/useMovementsState';
import { EmptyMovements } from '../../components/EmptyMovements';
import { MovementsSummaryCard } from './components/MovementsSummaryCard';
import { MovementListCard } from './components/MovementListCard';
import { MovementsSubHeader } from './components/MovementsSubHeader';
import {
  movementListFilterLabels,
  movementListFilterValues,
} from '../../constants/filterValues';

export function MovementListDesktopLayout() {
  const { movementsState, movementsSummaryState, refreshMovementsStates } =
    useMovementsState();
  const { hasFilters } = useFilterParams();
  const initialRender = useRef(true);
  const { getInitialFilter, setActiveFilters } = useDrawerFilter();

  const { data, isLoading, isError } = movementsState;

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      const initialFinancialFilters = getInitialFilter({
        filtersConfig: movementListFilterValues,
        filtersLabel: movementListFilterLabels,
      });

      setActiveFilters(initialFinancialFilters);
    }
  }, []);

  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }

  if (isError || movementsSummaryState?.isError) {
    return <ErrorLoadingPage onReloadClick={refreshMovementsStates} />;
  }

  const totalMovementListLength = movementsState?.data?.movements?.length ?? 0;

  const isEmpty = totalMovementListLength === 0;

  const isEmptyResult = isEmpty && hasFilters;

  if (isEmpty && !hasFilters) {
    return <EmptyMovements />;
  }

  const totalMovementsLength = movementsState?.data?.total ?? 0;
  const label = totalMovementsLength === 1 ? 'movimentação' : 'movimentações';
  const filterSummaryLabel = `${totalMovementsLength} ${label}`;

  return (
    <>
      <MovementsSubHeader />
      <Stack paddingTop={3} gap={3}>
        <FilterSummary totalLabel={filterSummaryLabel} />

        {isEmptyResult ? (
          <NoSearchResults padding={5} />
        ) : (
          data && (
            <Stack gap={3} paddingBottom={8}>
              <MovementsSummaryCard />

              <SummaryCardNew.Container>
                <SummaryCardNew.Header
                  subtitle="Últimos 30 dias"
                  title="Lista de movimentações"
                />
                <MovementListCard movementList={data} />
              </SummaryCardNew.Container>
            </Stack>
          )
        )}
      </Stack>
    </>
  );
}
